import { nanoid } from "nanoid";

const getUniquId = (type) => (type ? `${type}_${nanoid(6)}` : nanoid(6));

export default getUniquId;
